import { plantList } from '../datas/plantList'
import PlantItem from './PlantItem'
import '../styles/ShoppingList.css'
import Categories from './Categories'
import { useState, useEffect } from 'react';

function ShoppingList({cart,updateCart}) {
	const savedPlantCategorie = localStorage.getItem('plantCategorie');
	const [plantCategorie, setPlantCategorie] = useState(savedPlantCategorie ? JSON.parse(savedPlantCategorie) : []);
	
	useEffect(() => {
		localStorage.setItem('plantCategorie', JSON.stringify(plantCategorie))
	}, [plantCategorie])
	const categories = plantList.reduce(
		(acc, plant) =>
			acc.includes(plant.category) ? acc : acc.concat(plant.category),
		[]
	)
	
	const addToCart = (name, price) =>  {
		const currentPlantSaved = cart.find((plant) => plant.name === name)
		if (currentPlantSaved) {
			const cartFilteredCurrentPlant = cart.filter(
				(plant) => plant.name !== name
			)
			updateCart ([...cartFilteredCurrentPlant, {name,price, amount: currentPlantSaved.amount + 1}
			])	
		}
		else {
			updateCart([...cart, {name,price, amount:1}])
		}	 
	}

	return (
		<div className='lmj-shopping-list'>
			<Categories
				categories={categories}
				plantCategorie={plantCategorie}
				setPlantCategorie={setPlantCategorie}
				/>
			
			<ul className='lmj-plant-list'>
				{plantList.map(({ id, cover, name, water, light, price,category}) => 
					!plantCategorie || plantCategorie === category ? (
					<div key={id}> 
					<PlantItem
						cover={cover}
						name={name}
						water={water}
						light={light}
						price={price}
						category={category}
					/>
					<button className='add-button' onClick={() => addToCart(name, price)}><i class="fa-solid fa-plus"></i> Ajouter </button>
					</div>
				): null
				
				)}
			</ul>
			
		</div>
	)
}

export default ShoppingList
